import { TtsSettings } from 'src/app/services/text-to-speech.service';

export interface TtsSettingRow {
  label: string;
  value: string;
}

type Displayable = string | number | boolean | null | undefined;

function format(value: Displayable): string | null {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  if (typeof value === 'boolean') {
    return value ? 'On' : 'Off';
  }
  return String(value);
}

export function describeSettings(settings: TtsSettings | null | undefined): TtsSettingRow[] {
  if (!settings) {
    return [];
  }
  const voice = settings.voiceSettings ?? {};

  const entries: Array<[string, Displayable]> = [
    ['Voice ID', settings.voiceId],
    ['Model', settings.modelId],
    ['Language', settings.languageCode],
    ['Output format', settings.outputFormat],
    ['Text normalization', settings.applyTextNormalization],
    ['Stability', voice.stability],
    ['Similarity boost', voice.similarityBoost],
    ['Style', voice.style],
    ['Speaker boost', voice.useSpeakerBoost],
    ['Speed', voice.speed],
  ];

  return entries.map(([label, value]) => ({ label, value: format(value) })).filter((row): row is TtsSettingRow => row.value !== null);
}
